module.exports = __webpack_public_path__ + "logo-plentymarkets.3090a3143b8d01c2b128cc01385334dc.svg";